import { TFunction } from 'i18next'
import { StringSchema } from 'yup'

import { nonEmptyStringSchema, stringSchema } from '@/Shared/ui/form/validations'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const rEmail =
  // eslint-disable-next-line
  /^((([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/

export const emailSchema = (
  t: TFunction<'translation', undefined>,
  isRequired = true,
): StringSchema<string | undefined> => {
  const schema = isRequired ? nonEmptyStringSchema(t, 75) : stringSchema(t, 75)

  return schema
    .test(
      'no-disallowed-chars',
      t(formTranslation.errors.invalidEmailFormat),
      (value) => {
        if (!value) return true;
        const hasOnlyAllowedChars = /^[a-zA-Z0-9@._-]*$/.test(value);
        return hasOnlyAllowedChars;
      }
    )
    .matches(
      rEmail,
      t(formTranslation.errors.invalidFormat)
    );
}

export const emailSchemaStep2 = (
  t: TFunction<'translation', undefined>,
  isRequired = true,
): StringSchema<string | undefined> => {
  const schema = isRequired ? nonEmptyStringSchema(t, 75) : stringSchema(t, 75)

  return schema
    .test(
      'no-disallowed-chars',
      t(formTranslation.errors.invalidFormat),
      (value) => {
        if (!value) return true;
        const hasOnlyAllowedChars = /^[a-zA-Z0-9@._-]*$/.test(value);
        return hasOnlyAllowedChars;
      }
    )
    .matches(
      rEmail,
      t(formTranslation.errors.invalidFormat)
    );
}
